import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";

import "./Dashboard.css";

import history from "../../history";
import { SET_CURRENT_USER } from "../../actions/types";
import { getUser } from "../../actions/userActions";
import { sessionCheck } from "../../apis/backend";

import Header from "./Header";
import Navigation from "./Navigation";
import WorkingTime from "./Content/WorkingTime";
import RequestList from "./Content/RequestList";
import Request from "./Content/Request";
import NewRequest from "./Content/NewRequest";
import FormList from "./Content/FormList";
import NewForm from "./Content/NewForm";
import AbsenceReasons from "./Content/AbsenceReasons";
import AbsenceList from "./Content/AbsenceList";
import AbsenceLimits from "./Content/AbsenceLimits";
import PaycheckList from "./Content/PaycheckList";
import NewMenu from "./Content/NewMenu";
import MealReservationList from "./Content/MealReservationList";
import NewMealReservation from "./Content/NewMealReservation";
import MealOrderList from "./Content/MealOrderList";
import AddMissingMealOrders from "./Content/AddMissingMealOrders";
import UnsettledMealOrderList from "./Content/UnsettledMealOrderList";
import CanteenReportList from "./Content/CanteenReportList";
import CanteenReport from "./Content/CanteenReport";
import Structure from "./Content/Structure";
import EditSettings from "./Content/Structure/EditSettings";
import EditEmployees from "./Content/Structure/EditEmployees";
import EditSubUnits from "./Content/Structure/EditSubUnits";
import EditSupervisors from "./Content/Structure/EditSupervisors";
import ExternalUnit from "./Content/ExternalUnit";
import EditExternalEmployees from "./Content/ExternalUnit/EditExternalEmployees"
import NewExternalUnit from "./Content/NewExternalUnit"
import Settings from "./Content/Settings";
import Account from "./Content/Account";
import { Error404 } from "../ErrorScreen";
import Inactive from "../Inactive";
import Unassigned from "../Unassigned";

class Dashboard extends React.Component {
    constructor(props) {
        super(props);

        this.state = { render: false };
    }

    componentDidMount() {
        sessionCheck(false)
        .then(() => {
            this.setState({ render: true });
            this.props.getUser(this.props.auth.userID, SET_CURRENT_USER);
        })
        .catch(() => {});
    }

    onNavigationLoad = home => {
        if (history.location.pathname === "/") history.push(home)
    };

    render() {
        if (this.state.render) {
            return (
                <React.Fragment>
                    <div className="dashboard-component">
                        <Header />
                        <div className="ui grid">
                            <div className="two wide column">
                                <Navigation onLoad={this.onNavigationLoad} key={history.location.pathname} />
                            </div>
                            <div className="fourteen wide column">
                                <div className="dasboard-component child-component">
                                    <Switch>
                                        <Route path="/" exact render={() => <div />} />
                                        <Route path="/inactive" exact component={Inactive} />
                                        <Route path="/unassigned" exact component={Unassigned} />
                                        <Route path="/working-time/my" exact render={(props) => <WorkingTime {...props} type="my" />} />
                                        <Route path="/working-time/employees" exact render={(props) => <WorkingTime {...props} type="list" />} />
                                        <Route path="/working-time/external" exact render={(props) => <WorkingTime {...props} type="externalList" />} />
                                        <Route path="/working-time/employee/:userID" exact render={(props) => <WorkingTime {...props} type="report" />} />
                                        <Route path="/working-time/external/:userID" exact render={(props) => <WorkingTime {...props} type="externalReport" />} />
                                        <Route path="/requests/hr/pending" exact render={(props) => <RequestList {...props} listScope="hr" listType="pending" />} />
                                        <Route path="/requests/hr/other" exact render={(props) => <RequestList {...props} listScope="hr" listType="other" />} />
                                        <Route path="/requests/hr/all" exact render={(props) => <RequestList {...props} listScope="hr" listType="all" />} />
                                        <Route path="/requests/pending" exact render={(props) => <RequestList {...props} listScope="supervisor" listType="pending" />} />
                                        <Route path="/requests/other" exact render={(props) => <RequestList {...props} listScope="supervisor" listType="other" />} />
                                        <Route path="/requests/all" exact render={(props) => <RequestList {...props} listScope="supervisor" listType="all" />} />
                                        <Route path="/requests/my" exact render={(props) => <RequestList {...props} listType="my" />} />
                                        <Route path="/requests/details/:requestID" exact component={Request} />
                                        <Route path="/requests/new" exact component={NewRequest} />
                                        <Route path="/paychecks" exact component={PaycheckList} />
                                        <Route path="/menus/edit" exact component={NewMenu} />
                                        <Route path="/meal-reservations" exact component={MealReservationList} />
                                        <Route path="/meal-reservations/my" exact component={NewMealReservation} />
                                        <Route path="/meal-orders/my" exact render={(props) => <MealOrderList {...props} listType="my" />} />
                                        <Route path="/meal-orders/today" exact render={(props) => <MealOrderList {...props} listType="today" />} />
                                        <Route path="/meal-orders/missing" exact component={AddMissingMealOrders} />
                                        <Route path="/meal-orders/unsettled" exact component={UnsettledMealOrderList} />
                                        <Route path="/meal-orders/reports" exact component={CanteenReportList} />
                                        <Route path="/meal-orders/reports/details/:reportID" exact render={(props) => <CanteenReport {...props} mode="selected" />} />
                                        <Route path="/meal-orders/reports/new" exact render={(props) => <CanteenReport {...props} mode="new" />} />
                                        <Route path="/forms" exact component={FormList} />
                                        <Route path="/forms/new" exact render={(props) => <NewForm {...props} mode="new" />} />
                                        <Route path="/forms/edit/:formID" exact render={(props) => <NewForm {...props} mode="edit" />} />
                                        <Route path="/structure/unit/:ouID" exact component={Structure} />
                                        <Route path="/structure" exact component={Structure} />
                                        <Route path="/structure/edit/settings/:ouID" exact component={EditSettings} />
                                        <Route path="/structure/edit/employees/:ouID" exact component={EditEmployees} />
                                        <Route path="/structure/edit/employees" exact component={EditEmployees} />
                                        <Route path="/structure/edit/sub-units/:ouID" exact component={EditSubUnits} />
                                        <Route path="/structure/edit/sub-units" exact component={EditSubUnits} />
                                        <Route path="/structure/edit/supervisors/:ouID" exact component={EditSupervisors} />
                                        <Route path="/structure/external/details/:externalOuID" exact component={ExternalUnit} />
                                        <Route path="/structure/external/new" exact render={(props) => <NewExternalUnit {...props} mode="new" />} />
                                        <Route path="/structure/external/edit/:externalOuID" exact render={(props) => <NewExternalUnit {...props} mode="edit" />} />
                                        <Route path="/structure/external/edit/employees/:externalOuID" exact component={EditExternalEmployees} />
                                        <Route path="/absence/reasons" exact component={AbsenceReasons} />
                                        <Route path="/absence/hours" exact render={(props) => <AbsenceList {...props} type="hours" />} />
                                        <Route path="/absence/limits" exact component={AbsenceLimits} />
                                        <Route path="/absence" exact render={(props) => <AbsenceList {...props} type="absence" />} />
                                        <Route path="/settings" exact component={Settings} />
                                        <Route path="/account" exact render={(props) => <Account {...props} user="current" />} />
                                        <Route path="/users/details/:userID" exact render={(props) => <Account {...props} user="selected" />} />
                                        <Route path="/" component={Error404} />
                                    </Switch>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        else return null;
    }
}

const mapStateToProps = state => ({ auth: state.auth, currentUser: state.user.current });

export default connect(mapStateToProps, { getUser })(Dashboard);